export default {
      id: "route-guide-usage",
      viewBox: "0 0 22 25",
      url: "/" + "sprite.svg#route-guide",
      toString: function () {
        return this.url;
      }
    }